export const HARDWARE_WALLET_ERROR_CODE = -32602;
export const NETWORK_TRANSACTION_SUCCESS = 1;
export const USER_REJECTED_TRANSACTION = 4001;
